var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2963 2.82555C12.3048 2.93492 12.3048 3.04432 12.3048 3.15369C12.3048 6.48961 9.5552 10.3334 4.52979 10.3334C2.98155 10.3334 1.54332 9.91929 0.333496 9.20057C0.553471 9.224 0.764956 9.23181 0.993395 9.23181C2.27087 9.23181 3.44687 8.83339 4.38596 8.1537C3.1846 8.13025 2.17783 7.40369 1.83095 6.40369C2.00017 6.42711 2.16936 6.44274 2.34705 6.44274C2.59239 6.44274 2.83775 6.41148 3.06616 6.35682C1.81405 6.12242 0.874931 5.10681 0.874931 3.88024V3.84901C1.23871 4.03651 1.66176 4.15369 2.11012 4.1693C1.37407 3.71617 0.891858 2.94274 0.891858 2.06773C0.891858 1.59899 1.0272 1.1693 1.2641 0.7943C2.60929 2.32555 4.6313 3.32553 6.89863 3.43493C6.85633 3.24742 6.83094 3.05213 6.83094 2.85681C6.83094 1.46617 8.04923 0.333374 9.56361 0.333374C10.3504 0.333374 11.0611 0.638061 11.5602 1.13025C12.1778 1.02088 12.77 0.809931 13.2946 0.520875C13.0915 1.10683 12.6601 1.59901 12.0932 1.91149C12.6432 1.85683 13.1762 1.71618 13.6668 1.52088C13.2946 2.02086 12.8293 2.46616 12.2963 2.82555Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f9d9d9b6384d645d5268d20d3c197d2c.svg";
export { ForwardRef as ReactComponent };